import type { NavLink } from '@/types'

export const NAV_LINKS: Array<NavLink> = [
    { label: 'Product', href: '/#product' },
    { label: 'Safety', href: '/#safety' },
    { label: 'About', href: '/#about' },
    { label: 'Pricing', href: '/pricing' }
]

export const FOOTER_PRODUCT_LINKS: Array<NavLink> = [
    { label: 'Sample deal', href: '/#product' },
    { label: 'Features', href: '/#features' },
    { label: 'Safety', href: '/#safety' },
    { label: 'Pricing', href: '/pricing' }
]

export const FOOTER_COMPANY_LINKS: Array<NavLink> = [
    { label: 'About', href: '/#about' },
    { label: 'Book a demo', href: '/contact?topic=demo' },
    { label: 'Contact', href: '/contact' },
    { label: 'Privacy', href: '/privacy' }
]

export const DEMO_HREF = '/contact?topic=demo'
